var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:['ui-badge', `ui-badge--${_vm.variant}`, { pill: _vm.pill }],style:({ '--ui-font-size': _vm.fontSize + 'px' })},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.text))]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }